import React from 'react';
import {
  Link
} from "react-router-dom";
import { colors } from '../../theme';
import './landingPage-view.css';

class FooterView extends React.Component {

  render() {


    return (
      <section>
        <div style={{ backgroundColor: '#06283A' }}>
          <div className="container footer pt-5 pb-4 text-center text-md-left" >
            <div className="row mt-3">

              <div className="col-md-4 col-12 mx-auto mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>Download</strong>
                </h6>
                <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: 60 }} />
                <p>
                  <a href="https://apps.apple.com/us/app/moneyapp-online/id1575620079"><i className="fab fa-apple mr-2"></i>App Store</a>
                </p>
              </div>

              <div className="col-md-4 col-12 mx-auto mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>Legal</strong>
                </h6>
                <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: 60 }} />
                <p>
                  <a href="/termsandconditions">Terms and Conditions</a>
                </p>
                <p>
                  <a href="/privacypolicy">Privacy Policy</a>
                </p>
              </div>

              <div className="col-md-4 col-12 mx-auto mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>Contact</strong>
                </h6>
                <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: 60 }} />
                <p>
                  <i className="fa fa-envelope mr-3"></i> support@moneyapp.online</p>
                <p>
                  <i className="fa fa-phone mr-3"></i> +27(0) 72 128 0327</p>
              </div>

            </div>
            <div className="row">
              <div className="col-12 text-center" style={{ opacity: 0.7, paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.2)' }}>
                <small>&copy; {new Date().getFullYear()} MoneyApp. All rights reserved.</small>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FooterView;
